<!-- Pagina de detalhes de contato -->
<div class="background-class mat-typography">
  <!-- Alerta para o usuário -->
  <spe-alert [class]="apiStatus" [message]="message"></spe-alert>
  <spe-base-card titleLegend="Dados do contato">
    <form [formGroup]="contactDataForm">
      <div class="aligmnent-form-itens">
        <mat-form-field
          
          class="input-class-0"
          [ngClass]="commonService.switchMatErrorClassResponsivity(contactDataFormControl.nomeContato)"
        >
          <mat-label>Nome completo</mat-label>
          <input matInput type="text" formControlName="nomeContato" />
          <mat-error>
            {{ validatorErrors(contactDataFormControl.nomeContato) }}
          </mat-error>
        </mat-form-field>
        <mat-form-field
          
          class="input-class-1"
          [ngClass]="commonService.switchMatErrorClassResponsivity(contactDataFormControl.descricaoDepartamento)"
        >
          <mat-label>Departamento</mat-label>
          <mat-select name="listDepartment" formControlName="descricaoDepartamento">
            <mat-option *ngFor="let element of listDepartment" [value]="element.descricao">
              {{ element.descricao }}
            </mat-option>
          </mat-select>
          <mat-error>
            {{ validatorErrors(contactDataFormControl.descricaoDepartamento) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          
          class="input-class-1"
          [ngClass]="commonService.switchMatErrorClassResponsivity(contactDataFormControl.descricaoCargo)"
        >
          <mat-label>Cargo</mat-label>
          <mat-select name="listRoles" formControlName="descricaoCargo">
            <mat-option *ngFor="let element of listRoles" [value]="element.descricao">
              {{ element.descricao }}
            </mat-option>
          </mat-select>
          <mat-error>
            {{ validatorErrors(contactDataFormControl.descricaoCargo) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          
          class="input-class-1"
          [ngClass]="commonService.switchMatErrorClassResponsivity(contactDataFormControl.sexo)"
        >
          <mat-label>Sexo</mat-label>
          <mat-select name="listGender" formControlName="sexo">
            <mat-option *ngFor="let element of listGender" [value]="element.value">
              {{ element.viewValue }}
            </mat-option>
          </mat-select>
          <mat-error>
            {{ validatorErrors(contactDataFormControl.sexo) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          
          class="input-class-1"
          [ngClass]="commonService.switchMatErrorClassResponsivity(contactDataFormControl.dataAniversario)"
        >
          <mat-label>Data de nascimento</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="dataAniversario" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error>
            {{ validatorErrors(contactDataFormControl.dataAniversario) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          
          class="input-class-0"
          [ngClass]="commonService.switchMatErrorClassResponsivity(contactDataFormControl.flagResponsavel)"
        >
          <mat-label>É responsável pela compra de benefícios?</mat-label>
          <mat-select name="listFlagResponsible" formControlName="flagResponsavel">
            <mat-option *ngFor="let element of listFlagResponsible" [value]="element.value">
              {{ element.viewValue }}
            </mat-option>
          </mat-select>
          <mat-error>
            {{ validatorErrors(contactDataFormControl.flagResponsavel) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          
          class="input-class-0"
          [ngClass]="commonService.switchMatErrorClassResponsivity(contactDataFormControl.descricao)"
        >
          <mat-label>E-mail principal</mat-label>
          <input matInput speLowercase type="text" formControlName="descricao" />
          <mat-error>
            {{ validatorErrors(contactDataFormControl.descricao) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          
          class="input-class-0"
          [ngClass]="commonService.switchMatErrorClassResponsivity(contactDataFormControl.secundaryEmail)"
        >
          <mat-label>E-mail adicional</mat-label>
          <input matInput speLowercase type="text" formControlName="secundaryEmail" />
          <mat-error>
            {{ validatorErrors(contactDataFormControl.secundaryEmail) }}
          </mat-error>
        </mat-form-field>

        <div class="full-width">
          <form [formGroup]="registerListDataForm">
            <div formArrayName="register" *ngFor="let regi of registercontrol; let i = index">
              <div [formGroupName]="i" class="formListSpace">
                <div class="formList">
                  <mat-form-field  class="input-class-4">
                    <mat-label>Tipo</mat-label>
                    <mat-select
                      name="listTypeRegister"
                      formControlName="registerTypeNumber"
                      (selectionChange)="telTipEditSelect(i)"
                    >
                      <mat-option *ngFor="let element of listTypeRegister" [value]="element.id">
                        {{ element.descricao }}
                      </mat-option>
                    </mat-select>
                    <mat-error>
                      {{ validatorErrors(objectFormControl(regi).controls['registerTypeNumber'], true) }}
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field
                    
                    class="input-class-4"
                    *ngIf="!isTelTipEditEmail[i]"
                    [ngClass]="
                      commonService.switchMatErrorClassResponsivity(objectFormControl(regi).controls['registerNumber'])
                    "
                  >
                    <mat-label>Número</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="registerNumber"
                      mask="(00) 0000-0000|| (00) 00000-0000"
                    />
                    <mat-error>
                      {{ validatorErrors(objectFormControl(regi).controls['registerNumber'], true) }}
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field  class="input-class-5" *ngIf="!isTelTipEditEmail[i]">
                    <mat-label>Ramal</mat-label>
                    <input matInput type="text" formControlName="registerBranch" />
                    <mat-error>
                      {{ validatorErrors(objectFormControl(regi).controls['registerBranch'], true) }}
                    </mat-error>
                  </mat-form-field>

                  <mat-form-field
                    
                    class="input-class-6"
                    *ngIf="isTelTipEditEmail[i]"
                    [ngClass]="
                      commonService.switchMatErrorClassResponsivity(
                        objectFormControl(regi).controls['registerTipEmail']
                      )
                    "
                  >
                    <mat-label>E-mail</mat-label>
                    <input matInput speLowercase type="text" formControlName="registerTipEmail" />
                    <mat-error>
                      {{ validatorErrors(objectFormControl(regi).controls['registerTipEmail'], true) }}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="space-buttons-register">
                  <button
                    type="submit"
                    mat-button
                    class="style-small-buttons high-buttons button-register"
                    (click)="updateRegister(i, regi)"
                  >
                    Alterar registro
                  </button>
                  <button
                    type="button"
                    mat-button
                    class="style-small-buttons high-buttons button-register"
                    (click)="deleteRegister(i, regi)"
                  >
                    Excluir registro
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </form></spe-base-card
  >

  <spe-base-card titleLegend="Incluir novo registro">
    <form [formGroup]="registerDataForm">
      <div class="aligmnent-form-itens">
        <mat-form-field
          
          class="input-class-7"
          [ngClass]="commonService.switchMatErrorClassResponsivity(registerDataForm.controls.typeNumber)"
        >
          <mat-label>Tipo</mat-label>
          <mat-select
            name="listTypeRegister"
            formControlName="typeNumber"
            (selectionChange)="telTipAddSelect(registerDataFormControl.typeNumber.value)"
          >
            <mat-option *ngFor="let element of listTypeRegister" [value]="element.id">
              {{ element.descricao }}
            </mat-option>
          </mat-select>
          <mat-error>
            {{ validatorErrors(registerDataFormControl.typeNumber) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          
          class="input-class-7"
          *ngIf="!isTelTipAddEmail"
          [ngClass]="commonService.switchMatErrorClassResponsivity(registerDataFormControl.number)"
        >
          <mat-label>Número</mat-label>
          <input matInput type="text" formControlName="number" mask="(00) 0000-0000|| (00) 00000-0000" />
          <mat-error>
            {{ validatorErrors(registerDataFormControl.number) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          
          class="input-class-8"
          *ngIf="!isTelTipAddEmail"
          [ngClass]="commonService.switchMatErrorClassResponsivity(registerDataForm.controls.branch)"
        >
          <mat-label>Ramal</mat-label>
          <input matInput type="text" formControlName="branch" />
          <mat-error>
            {{ validatorErrors(registerDataFormControl.branch) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field
          
          class="input-class-9"
          *ngIf="isTelTipAddEmail"
          [ngClass]="commonService.switchMatErrorClassResponsivity(registerDataForm.controls.tipEmail)"
        >
          <mat-label>E-mail</mat-label>
          <input matInput speLowercase type="text" formControlName="tipEmail" />
          <mat-error>
            {{ validatorErrors(registerDataFormControl.tipEmail) }}
          </mat-error>
        </mat-form-field>

        <div class="space-buttons-register">
          <button
            type="button"
            mat-button
            class="style-small-buttons high-buttons button-register"
            (click)="
              addRegister(
                registerDataFormControl.typeNumber.value!,
                registerDataFormControl.number.value!,
                registerDataFormControl.branch.value!,
                registerDataFormControl.tipEmail.value!
              )
            "
          >
            Adicionar registro
          </button>
        </div>
      </div>
    </form>
  </spe-base-card>

  <div class="space-buttons">
    <button type="button" mat-button (click)="returnButton()" class="style-small-buttons outline-buttons">
      Voltar
    </button>
    <button
      type="button"
      mat-button
      (click)="saveContact()"
      class="black-style-button button-width-0"
      [ngClass]="{ caixaButton: sigla == 'CAIXA' }"
    >
      Salvar alterações
    </button>
  </div>
</div>
